export var OrganisationRoutes;
(function (OrganisationRoutes) {
    OrganisationRoutes["ORGANISATION"] = "organisation";
})(OrganisationRoutes || (OrganisationRoutes = {}));
export const mockedPlaceholders = {
    facebook: 'https://facebook.com/ASQ Global',
    instagram: 'https://instagram.com/ASQ Global',
    website2: 'https://website.com',
    twitter: 'https://twitter.com/ASQ Global',
    linkedin: 'https://linkedin.com/ASQ Global'
};
